<template>
    <div>
        <div class="wptop">
        <div class="fxwidth wpheader">
            <div class="hdback" @click="goBack"></div>
            <div class="hdtitle">帮助中心</div>
        </div>
            <div class="headerhd"></div>
        </div>

        <div class="helpbox">

            <div class="item">
                <div class="title">关于</div>
                <div>
                    亚讯体育专注足球赛事研究，以真实赛程、可验证数据和认证专家原创观点，为用户提供清晰、审慎的赛前分析服务。
                </div>
            </div>
            <div class="item">
                <div class="title">球币与积分</div>
                <p>1、100积分=1球币=1元</p>
                <p>2、球币可以充值或者发布赛事有订阅并命中即获得。</p>
                <p>3、积分可以签到或者发布赛事获得 ，积分可以随时转换为球币。</p>
                <p>4、球币可以随时提现但需扣除百分十的手续（提现3天内到帐）</p>
                <p>5、球币只可用于订阅本站专家方案，不能用于购买彩票，购买彩票请到线下或者线上竞彩店</p>
            </div>

            <div class="item">
                <div class="title">专家方案</div>
                <p>1、本站属于推介平台，每位专家发布的推介方案，由本站监督，杜绝作假。</p>
                <p>2、专家发布的方案，如有会员订阅并命中，专家即获得所设置的7成球币。</p>
                <p>3、会员订阅的方案如不中即退还所有球币。</p>
                <p>4、关注专家不迷路，导航栏的排行榜以及会员中心有每位专家的胜率明细可供参考，都是真实成绩。</p>
            </div>

            <div class="item">
                <div class="title">专家规则及奖励</div>
                <p>1、注册会员并联系客服申请成为专家，再经本站严格考核通过后即可发布推介；</p>
                <p>2、每位专家每天最多可发布10场推介；</p>
                <p>3、每发布一场推介可获得10积分奖励；</p>
                <p>4、发布的推介赢球即可获得20积分奖励；如有会员订阅并命中，即获得所设置的7成球币。</p>

                <div class="tips">
                <p class="sm">球币数量说明：</p>
                <p>专家可设置球币数量，根据15天胜率进行计算，具体如下</p>
                <p>胜率百分之50以下 数量0-50个</p>
                <p>胜率百分之51到60的 数量0-100个</p>
                <p>胜率百分之61到70的 数量0-500个</p>
                <p>胜率百分之71到80的 数量0-1000个</p>
                <p>胜率百分之81到90的 数量0-2000个</p>
                <p>胜率百分之91到100的 数量0-3000个</p>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: "help",
        data() {
            return {
                formPath: ''
            }
        },
        created() {

        },
        methods: {
            goBack(){
                let that = this
                this.$router.push({
                    path: that.formPath === '' ?'/':that.formPath
                })
            }
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path
            })
        }
    }
</script>

<style scoped>
</style>
